import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService, LogoComponent } from '@moawen-workspace/shared';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { NgbCollapseModule, NgbDropdownModule, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Router, RouterModule } from '@angular/router';
import { LoginService } from '../../services';
const noReloadRoutes = ['/workers/add-individual'];
@Component({
  selector: 'agency-core-header',
  standalone: true,
  imports: [CommonModule, RouterModule, LogoComponent, FontAwesomeModule,
    NgbCollapseModule,
    NgbDropdownModule, TranslocoModule,
  ], templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  userToken: string | null | undefined;
  #transloco = inject(TranslocoService);
  transService = inject(LanguageService);
  #LoginService = inject(LoginService);
  #router = inject(Router);
  sidebarOpen = true;
  message!: string;
  @Output() toggleSidebar: EventEmitter<void> = new EventEmitter();
  isNavbarCollapsed = true;
  ngOnInit(): void {
    this.#LoginService.currentUser.subscribe(msg => {
      this.isUserLoggedIn();
    });
  }
  isUserLoggedIn() {
    this.userToken = this.#LoginService.getToken();
    console.log(this.userToken);

  }
  logout() {
    this.#LoginService.logout();
    this.isUserLoggedIn();
    this.#router.navigate(['']);


  }
  get currentLang() {
    return this.#transloco.getActiveLang();
  }

  onLangChange(event: any) {
    console.log(event);
    const currentRoute = this.#router.url;

    const lang = event === 'en' ? 'ar' : 'en';
    console.log(lang);

    this.#transloco.setActiveLang(lang);
    localStorage.setItem('lang', lang);
    this.transService.setDocumentLangDir(lang);
    // Prevent reload if current URL starts with /workers/add-individual
    if (!currentRoute.startsWith('/workers/add-individual')) {
      window.location.reload();
    }
    // window.location.reload();
  }


  onToggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
    this.toggleSidebar.emit();
  }

  goToProfile() {
    console.log('Navigating to profile...');
  }
  private offcanvasService = inject(NgbOffcanvas);
  openEnd(content: TemplateRef<any>) {
    this.offcanvasService.open(content, { position: 'end', panelClass: 'menu-collapse' });
  }
}
